import axios from './request'
import qFetch from '@/utils/qFetch'

export function getPromotionDetail(id) {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/bingo/h5/promotion/cms/detail', {
  // return axios.post('https://pwa.tujia.com/feapi/bingo/h5/promotion/cms/detail', {
    id: id
  })
}

export function getPromotionDetailForQ(id) {
  const url = '/bnbbingo/app/promotion/cms/detail'
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: {
      id: id
    },
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res.value)
  })
}

// BI数据接口
export function getHouseGroup(tableName) {
  return axios.post('/dbapi/api/cmsHouseGroup', {
  // return axios.post('https://pwa.tujia.com/api/cmsHouseGroup', {
    appdcode: 'fetujia-cms',
    tableName: tableName
  })
}

export function getPromotionDetailForMayi(id) {
  return axios.post('/feapi/mayipromotionweb/mayibingo/h5/promotion/cms/detail', {
    id: id
  })
}

export function getPromotionPreview(id) {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/bingo/h5/promotion/cms/preview', {
    previewToken: id
  })
}

export function getPromotionPreviewForMayi(id) {
  return axios.post('/feapi/mayipromotionweb/mayibingo/h5/promotion/cms/preview', {
    previewToken: id
  })
}

export function getQRcode(url) {
  const index = url.lastIndexOf('/')
  const code = url.substring(index + 1, url.length)
  return axios
    .post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/bingo/h5/wechat/getwxacode', {
      page: 'pages/webview/index',
      scene: 'gcd' + code
    })
    .then((ret) => {
      if (ret.errcode === 0) {
        return Promise.resolve(ret.data.wxACodeByteArray)
      } else {
        return Promise.resolve(null)
      }
    })
}

export function getUserInfo() {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/bingo/h5/Config/getCommonConfigs', {})
}
export function getUserInfoForMayi() {
  return axios.post('/feapi/mayipromotionweb/mayibingo/h5/config/getCommonConfigs', {})
}
